// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.assets_overview_title {
  font-size: 40px;
  font-weight: 600;
  margin: 6px 0 0px;
  color: #0f172a;
  border-bottom: 1px solid #E5E7EB;
  padding-bottom: 15px;
}

.assets_overview_bl_inner {
  display: grid;
  grid-template-columns: 1fr 320px;
  gap: 18px;
  align-items: start;
}

.assets_overview_bl_inner_rgt {
  min-width: 334px;
  border-left: 1px solid #E5E7EB;
  padding-left: 24px;
  padding-top: 28px;
  padding-right: 24px;
  color: #0f172a;
}

.assets_overview_bl_inner_lft {
  padding-top: 28px;
}

@media (max-width: 991.98px) {
  .assets_overview_bl_inner {
    grid-template-columns: 1fr;
  }
}

/* Mobile + tablet (< lg): 2 columns only — Coin + Total Balance; more btn after price; thead hidden */
@media (max-width: 991.98px) {

  .dashboard_summary .desktop_view-2 table thead,
  .dashboard_summary.account_table table thead {
    display: none !important;
  }

  /* Crypto — same column order as spot / funding wallet (Coin + Total on mobile): hide cols 3–6 */
  .dashboard_summary .desktop_view-2 table thead th:nth-child(3),
  .dashboard_summary .desktop_view-2 table thead th:nth-child(4),
  .dashboard_summary .desktop_view-2 table thead th:nth-child(5),
  .dashboard_summary .desktop_view-2 table thead th:nth-child(6),
  .dashboard_summary .desktop_view-2 table tbody td:nth-child(3),
  .dashboard_summary .desktop_view-2 table tbody td:nth-child(4),
  .dashboard_summary .desktop_view-2 table tbody td:nth-child(5),
  .dashboard_summary .desktop_view-2 table tbody td:nth-child(6) {
    display: none;
  }

  /* Account: Account + Amount */
  .dashboard_summary.account_table table thead th:nth-child(3),
  .dashboard_summary.account_table table thead th:nth-child(4),
  .dashboard_summary.account_table table tbody td:nth-child(3),
  .dashboard_summary.account_table table tbody td:nth-child(4) {
    display: none;
  }

  /* Wallet /spot: Coin + Total Amount */
  .dashboard_right.funding-account.wallet-page--ao-popup .funding-account__tablewrap {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }

  .dashboard_right.funding-account.wallet-page--ao-popup .funding-account__table {
    display: table !important;
    width: 100%;
    border-collapse: collapse !important;
    border-spacing: 0 !important;
  }

  .dashboard_right.funding-account.wallet-page--ao-popup .funding-account__table thead {
    display: none !important;
  }

  .dashboard_right.funding-account.wallet-page--ao-popup .funding-account__table tbody {
    display: table-row-group !important;
  }

  .dashboard_right.funding-account.wallet-page--ao-popup .funding-account__table tbody tr {
    display: table-row !important;
    background: transparent !important;
    border: none !important;
    border-radius: 0 !important;
    box-shadow: none !important;
    margin-bottom: 0 !important;
  }

  .dashboard_right.funding-account.wallet-page--ao-popup .funding-account__table tbody td {
    display: table-cell !important;
    vertical-align: middle;
    padding: 10px 2px !important;
    border-top: none !important;
  }

  .dashboard_right.funding-account.wallet-page--ao-popup .funding-account__table tbody td[data-label]::before {
    display: none !important;
    content: none !important;
  }

  .dashboard_right.funding-account.wallet-page--ao-popup .funding-account__table thead th:nth-child(n+3),
  .dashboard_right.funding-account.wallet-page--ao-popup .funding-account__table tbody td:nth-child(n+3) {
    display: none !important;
  }
}

.agce-ao-more-btn {
  border: none;
  background: transparent;
  padding: 6px;
  line-height: 1;
  cursor: pointer;
  color: inherit;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.agce-ao-more-btn .ri-more-2-fill {
  font-size: 1.35rem;
  vertical-align: middle;
}

body.light_theme .agce-ao-more-btn {
  color: #0f172a;
}

.agce-ao-est-donutwrap {
  flex: 0 0 auto;
  display: inline-flex;
  align-items: center;
  justify-content: flex-end;
  gap: 12px;
  margin-left: 12px;
}

.agce-ao-est-donut {
  flex: 0 0 auto;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 124px;
  height: 124px;
}

.agce-ao-donut {
  display: block;
}

.agce-ao-donut-legend {
  min-width: 150px;
  max-width: 220px;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.agce-ao-donut-legend__row {
  display: grid;
  grid-template-columns: 10px 1fr auto;
  align-items: center;
  gap: 8px;
  font-size: 12px;
  line-height: 1.2;
  color: #e2e8f0;
  opacity: 0.95;
}

body.light_theme .agce-ao-donut-legend__row {
  color: #0f172a;
}

.agce-ao-donut-legend__dot {
  width: 10px;
  height: 10px;
  border-radius: 999px;
  display: inline-block;
  box-shadow: 0 0 0 1px rgba(255, 255, 255, 0.12), 0 2px 6px rgba(0, 0, 0, 0.35);
}

body.light_theme .agce-ao-donut-legend__dot {
  box-shadow: 0 0 0 1px rgba(15, 23, 42, 0.16), 0 2px 6px rgba(0, 0, 0, 0.15);
}

.agce-ao-donut-legend__label {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.agce-ao-donut-legend__value {
  font-variant-numeric: tabular-nums;
  color: #94a3b8;
}

body.light_theme .agce-ao-donut-legend__value {
  color: #475569;
}

.agce-ao-donut-legend__empty {
  font-size: 12px;
  color: #94a3b8;
}

.agce-ao-detail-backdrop {
  position: fixed;
  inset: 0;
  z-index: 1055;
  animation: ao-fade-in 160ms ease-out both;
}

@keyframes ao-fade-in {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

/* Row popup: label left, value right (same line) */
.agce-ao-detail-list {
  margin: 0;
}

.agce-ao-detail-row {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 12px;
  padding: 12px 0;
}

.agce-ao-detail-row:last-of-type {
  border-bottom: none;
  padding-bottom: 0;
}

.agce-ao-detail-row:first-of-type {
  padding-top: 0;
}

.agce-ao-est-donut feDropShadow {
  flood-color: aliceblue;
}

.estimated_balance .wallet-title {
  margin: 10px 0px 10px;
}

.agce-ao-detail-row dt {
  flex: 0 1 auto;
  max-width: 48%;
  margin: 0;
  font-weight: 400;
  color: #000000;
  font-size: 14px;
  line-height: 1.35;
}

.agce-ao-detail-row dd {
  flex: 0 1 auto;
  margin: 0;
  text-align: right;
  font-weight: 500;
  font-size: 14px;
  line-height: 1.35;
  color: #f1f5f9;
  max-width: 52%;
}

body.light_theme .agce-ao-detail-row dd {
  color: #0f172a;
}

.agce-ao-detail-value {
  display: block;
}

.agce-ao-detail-sub {
  display: block;
  margin-top: 4px;
  font-size: 12px;
  font-weight: 400;
  color: #94a3b8;
}

.agce-ao-detail-actions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding-top: 16px;
  margin-top: 0px;
}

.agce-ao-detail-actions-label {
  flex: 0 0 auto;
  margin: 0;
  font-size: 14px;
  /* font-weight: 500; */
  color: #0c0c0c;
}

.modal-dialog .agce-ao-detail-actions .btn-sm {
  color: #000;
}

.agce-ao-detail-actions-btns {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  justify-content: flex-end;
  align-items: center;
  flex: 1 1 auto;
  min-width: 0;
}

body.light_theme .agce-ao-detail-actions {
  border-top-color: #e5e7eb;
}

/* Left column */
.agce-assets {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.agce-assets__topcard {
  border: 1px solid #E5E7EB;
  border-radius: 16px;
  padding: 16px 16px 14px;
  background: linear-gradient(90deg, rgba(252, 253, 255, 1) 0%, rgba(242, 248, 255, 1) 100%);
}

.agce-assets__topcard-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.agce-assets__topcard-meta {
  display: flex;
  align-items: center;
  gap: 10px;
}

.agce-assets__label {
  font-size: 12px;
  font-weight: 400;
  color: #64748b;
  letter-spacing: -0.15px;
}

.agce-assets__chip {
  border: 1px solid #D1D5DC;
  background: #F3F4F6;
  border-radius: 10px;
  padding: 4px 10px;
  font-size: 12px;
  font-weight: 600;
  color: #0f172a;
  display: inline-flex;
  align-items: center;
  gap: 4px;
}

.agce-assets__select {
  position: relative;
  display: inline-flex;
}

.agce-assets__menu {
  position: absolute;
  top: calc(100% + 8px);
  left: 0;
  min-width: 140px;
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  box-shadow: 0 16px 40px rgba(15, 23, 42, 0.12);
  padding: 6px;
  z-index: 50;
}

.agce-assets__menu-item {
  width: 100%;
  border: 0;
  background: transparent;
  padding: 10px 10px;
  border-radius: 10px;
  font-size: 12px;
  font-weight: 700;
  color: #0f172a;
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
}

.agce-assets__menu-item:hover {
  background: #f1f5f9;
}

.agce-assets__menu-item.is-active {
  background: #eef2f7;
}

.agce-assets__menu-item i {
  font-size: 16px;
  color: #16a34a;
}

.agce-assets__iconbtn {
  border: 0;
  background: transparent;
  color: #94a3b8;
  padding: 6px;
  border-radius: 10px;
  cursor: pointer;
}

.agce-assets__iconbtn:hover {
  background: #f1f5f9;
  color: #475569;
}

.agce-assets__topcard-main {
  margin-top: 10px;
}

.agce-assets__amount {
  display: flex;
  align-items: baseline;
  gap: 8px;
}

.agce-assets__amount-num {
  font-size: 48px;
  font-weight: 700;
  letter-spacing: -0.04em;
  line-height: 1;
}

.agce-assets__amount-unit {
  font-size: 24px;
  font-weight: 400;
  color: #94a3b8;
  text-transform: uppercase;
  letter-spacing: 0.03em;
}

.agce-assets__subrow {
  margin-top: 8px;
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 12px;
  font-weight: 400;
}

.agce-assets__muted {
  color: #94a3b8;
}

.agce-assets__pnl {
  color: #16a34a;
}

.agce-assets__panel {
  background: #ffffff;
  border: 1px solid #EDEFF2;
  border-radius: 14px;
  overflow: hidden;
}

.agce-assets__panel-head {
  padding: 18px 16px 14px;
  border-bottom: 1px solid #eef2f7;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.agce-assets__panel-title {
  margin: 0;
  font-size: 18px;
  letter-spacing: -0.20px;
  color: #303236;
  font-weight: 500;
}

.agce-assets__panel-tools {
  display: inline-flex;
  align-items: center;
  gap: 12px;
  flex: 0 0 auto;
}

.agce-assets__panel-search {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 0;
  transition: padding 240ms ease, border-color 240ms ease, background-color 240ms ease, box-shadow 240ms ease;
  border: 0;
  border-radius: 10px;
  background: transparent;
  color: #64748b;
}

.agce-assets__panel-searchbtn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  border-radius: 10px;
  border: 1px solid #e5e7eb;
  background: #fff;
  color: #64748b;
  cursor: pointer;
}

/* .agce-assets__panel-searchbtn:hover {
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.12);
  border-color: #cbd5e1;
} */

.agce-assets__panel-search.is-open {
  padding: 2px 10px;
  border: 1px solid #e5e7eb;
  background: #fff;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.10);
}

.agce-assets__panel-search.is-open .agce-assets__panel-searchbtn {
  border: none;
}

.agcx-assets__panel-search.is-open .agcx-assets__panel-searchbtn:hover {
  box-shadow: none;
}

.agcx-assets__panel-search input {
  border: 0;
  outline: none;
  font-size: 13px;
  width: 160px;
  background: transparent;
  color: #0f172a;
}

/* Smooth expand animation (input mounts on click) */
.agcx-assets__panel-search.is-open input {
  transform-origin: left center;
  animation: agcx-panel-search-expand 240ms ease-out both;
}

@keyframes agcx-panel-search-expand {
  from {
    opacity: 0;
    transform: translateX(-6px);
    max-width: 0;
  }

  to {
    opacity: 1;
    transform: translateX(0);
    max-width: 160px;
  }
}

.agcx-assets__panel-hide0 {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  color: #475569;
  -webkit-user-select: none;
          user-select: none;
  margin: 0;
}

.assets_overview_bl {
  padding-left: 35px;
  padding-right: 36px;
}

.agcx-assets__table {
  width: 100%;
  overflow-x: auto;
  min-height: 460px;
}

.agcx-assets__table-el {
  width: 100%;
  border-collapse: collapse;
}

.agcx-assets__table-el thead th {
  padding: 12px 16px;
  font-size: 12px;
  font-weight: 500;
  letter-spacing: -0.15px;
  color: #94a3b8;
  text-transform: none;
  border-bottom: 1px solid #eef2f7;
  white-space: nowrap;
}

.agcx-assets__table-el tbody td {
  padding: 14px 16px;
  border-top: 1px solid #f1f5f9;
  vertical-align: middle;
}

.agcx-assets__coin {
  display: flex;
  align-items: center;
  gap: 5px;
  min-width: 0;
}

.agcx-assets__coin-icon {
  width: 40px;
  height: 40px;
  border-radius: 999px;
  /* background: #f8fafc; */
  /* border: 1px solid #eef2f7; */
  display: grid;
  place-items: center;
  overflow: hidden;
  flex: 0 0 auto;
}

.agce-assets__coin-icon img {
  width: 32px;
  height: 32px;
  object-fit: contain;
}

.agce-assets__coin-text {
  min-width: 0;
}

.agce-assets__coin-sym {
  font-size: 15px;
  font-weight: 600;
  /* color: #0f172a; */
  line-height: 1.1;
}

.agce-assets__coin-name {
  font-size: 12px;
  color: #94a3b8;
  font-weight: 400;
  letter-spacing: -0.15px;
}

.agce-assets__right {
  text-align: right;
}

.agce-assets__price {
  font-size: 14px;
  font-weight: 600;
}

td.agce-assets__right.agce-assets__chg.is-up {
  text-align: right;
  width: 100%;
}

.agce-assets__chg {
  font-size: 12px;
  font-weight: 400;
  display: inline-flex;
  align-items: center;
  justify-content: flex-end;
  gap: 6px;
}

.agce-assets__chg.is-up {
  color: #16a34a;
}

.agce-assets__chg.is-down {
  color: #dc2626;
  text-align: right;
  width: 100%;
}

.agce-assets__chg-icon i {
  font-size: 14px;
}

.agce-assets__more {
  border: 0;
  background: transparent;
  color: #94a3b8;
  cursor: pointer;
  padding: 6px;
  border-radius: 10px;
}

.agce-assets__more:hover {
  background: #f1f5f9;
  color: #475569;
}

.agce-assets__more-actions {
  display: inline-flex;
  justify-content: flex-end;
  align-items: center;
  gap: 10px;
}

.agce-assets__actionbtn {
  border: 0;
  background: transparent;
  color: #0f172a;
  font-weight: 600;
  font-size: 13px;
  padding: 6px 8px;
  border-radius: 10px;
  cursor: pointer;
  text-decoration: none;
  display: inline-flex;
  align-items: center;
}

.agce-assets__actionbtn:hover {
  background: #f1f5f9;
}

.agce-assets__actionbtn--ghost {
  color: #0f172a;
}

.agce-assets__actionbtn--ghost:hover {
  background: #f1f5f9;
}

@media (max-width: 767.98px) {

  .agce-assets__table-el thead th,
  .agce-assets__table-el tbody td {
    padding-left: 12px;
    padding-right: 12px;
  }
}

/* Right column */
.agce-assets-side {
  display: flex;
  flex-direction: column;
  gap: 14px;
  padding-right: 0px;
  width: 100%;
}

.agce-assets-side__card {
  background: #ffffff;
}

.agce-assets-side__card--market {
  background: #F1F6FF;
  border: 1px solid #BEDBFF;
  padding: 18px;
  border-radius: 18px;
}

.agce-assets-side__card-title {
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 10px;
}

.agce-assets-side__actions {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.agce-assets-side__action {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  position: relative;
  text-decoration: none;
  padding: 16px;
  border-radius: 12px;
  border: 1px solid #eef2f7;
  background: #ffffff;
  color: inherit;
}

.agce-assets-side__action i.ri-arrow-right-s-line {
  position: absolute;
  right: 16px;
  top: 50%;
  transform: translateY(-50%);
}

.agce-assets-side__action-text {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}

.agce-assets-side__action-h {
  font-size: 15px;
  font-weight: 600;
  /* color: #0f172a; */
  letter-spacing: -0.32px;
}

.agce-assets-side__action-p {
  font-size: 12px;
  font-weight: 500;
  line-height: 1.35;
  opacity: 0.9;
}

.agce-assets-side__action--deposit {
  background: #FFF6E8;
  border-color: #FFF6E8;
}

/* .agce-assets-side__action--buy{ background: #eaf8f0; }
.agce-assets-side__action--fiat{ background: #fff1f2; } */

.agce-assets-side__rowhead {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
}

.agce-assets-side__morelink {
  font-size: 11px;
  font-weight: 500;
  color: #D1AA67;
  text-decoration: none;
}

.agce-assets-side__morelink:hover {
  color: #475569;
  text-decoration: underline;
}

.agce-assets-side__empty {
  border: 1px solid #E5E7EB;
  border-radius: 12px;
  padding: 42px 14px;
  display: grid;
  justify-items: center;
  gap: 8px;
}

.agce-assets-side__empty-icon {
  width: 54px;
  height: 54px;
  border-radius: 50px;
  background: #F3F4F6;
  border: none;
  display: grid;
  place-items: center;
  color: #94a3b8;
  font-size: 22px;
}

.agce-assets-side__empty-text {
  font-size: 14px;
  color: #4A5565;
  font-weight: 500;
  margin: 5px 0px 2px;
}

.agce-assets-side__pill {
  font-size: 10px;
  font-weight: 500;
  padding: 5px 10px;
  border-radius: 999px;
  background: #DCFCE7;
  color: #008236;
  border: 1px solid #B9F8CF;
}

.agce-assets-side__market-value {
  font-size: 24px;
  font-weight: 700;
  color: #0f172a;
  letter-spacing: -0.02em;
  margin-bottom: 2px;
}

.agce-assets-side__market-sub {
  font-size: 12px;
  font-weight: 500;
  color: #008236;
}

.agce-assets-side__action:hover {
  color: #000;
}


@media (max-width: 1440px) {


  .assets_overview_title {
    font-size: 36px;
  }

  .agce-assets-side__empty {
    padding: 18px 14px;
  }

  .assets_overview_bl {
    padding-left: 22px;
    padding-right: 20px;
  }

}

@media (max-width: 1366px) {

  .assets_overview_bl {
    padding-left: 10px;
    padding-right: 0px;
  }

}

@media (max-width: 1024px) {


  .assets_overview_bl_inner {
    grid-template-columns: 1fr;
  }

  .assets_overview_title {
    font-size: 26px;
  }

  .agce-assets-side__action {
    justify-content: start;
  }

  .assets_overview_bl_inner_rgt {
    padding-left: 0px;
    border-left: none;
    padding-top: 15px;
    padding-right: 0px;
  }

}

@media (max-width: 991px) {

  .d-flex.align-items-center.justify-content-start.gap-2.agce-ao-mobile-total-with-more {
    justify-content: flex-end !important;
    text-align: right;
  }

  .modal {
    align-items: end;
  }

}


@media (max-width: 767px) {

  .assets_overview_title {
    font-size: 20px;
    border: none;
    padding-bottom: 5px;
  }

  .agce-ao-balance-stack {
    white-space: nowrap;
  }


  .modal-content.agce-ao-sheet .agce-ao-sheet__divider {
    display: none;
  }


  .modal-content.agce-ao-sheet .agce-ao-sheet__table-actions {
    margin-top: 20px;
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .assets_overview_bl_inner_lft {
    padding-top: 10px;
  }

  .agce-ao-sheet__kv {
    font-size: 14px;
  }

  .agce-assets__coin-sym {
    font-size: 12px;
  }

  .agce-assets__coin-name {
    font-size: 10px;
  }

  .agce-assets__table-el tbody td {
    padding: 10px 9px;
    font-size: 12px;
  }

  .assets_overview_bl {
    padding-left: 0px;
  }

  .agcx-assets__amount-num {
    font-size: 36px;
  }

  .agcx-assets__amount-unit {
    font-size: 18px;
  }

}

/* Asset Overview: icon-only until \`.search_active\`; expand width smoothly after click (see index.js). */
.dashboard_listing_section.Overview_mid .market_section .coin_right .searchBar.custom-tabs {
  transition: 0.5s all;
}

.dashboard_listing_section.Overview_mid .market_section .coin_right .agcx-assets-search__trigger {
  border: 0;
  background: transparent;
  padding: 0;
  margin: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: inherit;
  flex-shrink: 0;
  width: 100%;
  min-height: 22px;
}

.dashboard_listing_section.Overview_mid .market_section .coin_right .agcx-assets-search__trigger:focus-visible {
  outline: 2px solid rgba(252, 213, 53, 0.85);
  outline-offset: 2px;
  border-radius: 8px;
}

.dashboard_listing_section.Overview_mid .market_section .coin_right .agcx-assets-search__trigger i {
  font-size: 18px;
  line-height: 1;
}

.dashboard_listing_section.Overview_mid .market_section .coin_right .searchBar.custom-tabs.search_active {
  width: 280px;
  max-width: 100%;

}

.dashboard_listing_section.Overview_mid .market_section .coin_right .searchBar.custom-tabs.search_active .agcx-assets-search__trigger {
  width: auto;
}

.dashboard_listing_section.Overview_mid .market_section .coin_right .searchBar.custom-tabs.search_active .custom_search {
  display: block !important;
  flex: 1 1;
  min-width: 0;
}

/* Mobile row: total column shows main balance + fiat subline; desktop shows number only */
.agcx-ao-balance-stack {
  display: inline-flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 2px;
  text-align: right;
}

.agcx-ao-balance-stack__main {
  font-weight: 600;
  line-height: 1.2;
}

.agcx-ao-balance-stack__fiat {
  display: none;
  font-size: 12px;
  font-weight: 400;
  color: #64748b;
  line-height: 1.2;
}

@media (max-width: 767.98px) {
  .agcx-ao-balance-stack__fiat {
    display: block;
  }

  .total_balance_text {
    display: none;
  }
}

.agcx-ao-account-amount-stack {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

td.ta-r.agcx-ao-total-balance-cell .funding-account__subnum {
  text-align: left;
}

td.ta-r.agcx-ao-total-balance-cell.asstes_tdfirst .agcx-ao-balance-stack {
  align-items: start;
  text-align: left;
}



.agcx-ao-account-amount-stack__main {
  font-weight: 500;
  line-height: 1.25;
}

.agcx-ao-account-amount-stack__fiat {
  font-size: 12px;
  font-weight: 400;
  color: #64748b;
}

/* Row-detail overlay: d-flex (replaces d-block) so dialog + bottom sheet align correctly */
.modal.agcx-ao-sheet-modal.d-flex {
  align-items: center;
  justify-content: center;
  animation: ao-fade-in 160ms ease-out both;
}

/* Same overlay class used in JSX after agce rename */
.modal.agce-ao-sheet-modal.d-flex {
  align-items: center;
  justify-content: center;
  animation: ao-fade-in 160ms ease-out both;
  background-color: rgb(0 0 0 / 40%) !important;
  -webkit-backdrop-filter: blur(5px);
          backdrop-filter: blur(5px);
}

body.light_theme .modal.agce-ao-sheet-modal.d-flex {
  background-color: rgb(255 255 255 / 20%) !important;
}

@media (max-width: 991.98px) {
  .modal.agcx-ao-sheet-modal.d-flex {
    align-items: flex-end;
    justify-content: center;
    padding-left: 0;
    padding-right: 0;
    padding-bottom: 0;
  }


  body .agcx-ao-sheet__table-actions .btn-link.text-success {
    color: #000 !important;
  }

  .agcx-ao-balance-stack {
    white-space: nowrap;
  }
}

/* Bottom sheet–style row detail modal */
.agcx-ao-sheet-dialog {
  max-width: 520px;
  margin: 1rem auto;
}

.agcx-ao-sheet.modal-content {
  background: #ffffff;
  color: #0f172a;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 16px 48px rgba(15, 23, 42, 0.12);
  animation: ao-pop-in 180ms cubic-bezier(0.2, 0.8, 0.2, 1) both;
}

.agce-ao-sheet.modal-content {
  animation: ao-pop-in 180ms cubic-bezier(0.2, 0.8, 0.2, 1) both;
  background: #1e202691;
  color: #f0f0f0;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 16px 48px rgba(0, 0, 0, 0.55);
}

body.light_theme .agce-ao-sheet.modal-content {
  background: #ffffff75;
  color: #0f172a;
  box-shadow: 0 16px 48px rgba(15, 23, 42, 0.12);
}

body:not(.light_theme) .agcx-ao-sheet.modal-content {
  background: #0f172a;
  color: #f8fafc;
  box-shadow: 0 16px 48px rgba(0, 0, 0, 0.45);
}

@media (max-width: 991.98px) {
  .agcx-ao-sheet-dialog {
    margin: 0;
    max-width: 100%;
    width: 100%;
    min-height: auto;
    height: auto;
    display: flex;
    align-items: flex-end;
    padding: 0;
  }

  .agce-ao-sheet-dialog .modal-content.agce-ao-sheet {
    border-radius: 16px;
    max-height: min(92vh, 900px);
    overflow: hidden;
    display: flex;
    flex-direction: column;
    box-shadow: 0 24px 48px rgba(0, 0, 0, 0.55), 0 10px 24px rgba(0, 0, 0, 0.35);
    animation: ao-sheet-up 220ms cubic-bezier(0.2, 0.8, 0.2, 1) both;
  }

  body.light_theme .agce-ao-sheet-dialog .modal-content.agce-ao-sheet {
    box-shadow: inset 0 1px 0 rgb(246 246 246), 0 24px 48px rgba(15, 23, 42, 0.12), 0 10px 24px rgb(15 23 42 / 39%);
  }

  .agce-ao-sheet-dialog .agce-ao-sheet__body {
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
  }
}

@keyframes ao-pop-in {
  from {
    opacity: 0;
    transform: translateY(8px) scale(0.98);
  }

  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

@keyframes ao-sheet-up {
  from {
    transform: translateY(18px);
  }

  to {
    transform: translateY(0);
  }
}

@media (prefers-reduced-motion: reduce) {

  .agce-ao-detail-backdrop,
  .modal.agcx-ao-sheet-modal.d-flex,
  .modal.agce-ao-sheet-modal.d-flex,
  .agcx-ao-sheet.modal-content,
  .agce-ao-sheet.modal-content,
  .agce-ao-sheet-dialog .modal-content.agce-ao-sheet {
    animation: none !important;
  }
}

.agce-ao-sheet__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 16px 16px 12px;
  border-bottom: 1px solid #e5e7eb;
}

body:not(.light_theme) .agce-ao-sheet__header {
  border-bottom-color: #1e293b;
}

.agce-ao-sheet__brand {
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
}

.agce-ao-sheet__coin {
  width: 44px;
  height: 44px;
  border-radius: 50%;
  object-fit: cover;
  flex-shrink: 0;
}

.agce-ao-sheet__account-badge {
  width: 44px;
  height: 44px;
  border-radius: 50%;
  background: linear-gradient(135deg, #e2e8f0, #cbd5e1);
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  font-size: 18px;
  color: #0f172a;
  flex-shrink: 0;
}

.agce-ao-sheet__sym {
  font-size: 18px;
  font-weight: 700;
  line-height: 1.2;
}

.agce-ao-sheet__fullname {
  font-size: 13px;
  font-weight: 400;
  color: #64748b;
  margin-top: 2px;
  line-height: 1.25;
}

body:not(.light_theme) .agce-ao-sheet__fullname {
  color: #94a3b8;
}

.agce-ao-sheet__close {
  flex-shrink: 0;
}

body:not(.light_theme) .agce-ao-sheet__close {
  filter: invert(1) grayscale(1);
  opacity: 0.85;
}

.agce-ao-sheet__body {
  padding: 16px 16px 20px;
}

.agce-ao-sheet__hero {
  margin-bottom: 12px;
}

.agce-ao-sheet__hero-num {
  font-size: 28px;
  font-weight: 700;
  letter-spacing: -0.02em;
  line-height: 1.15;
  word-break: break-all;
}

.agce-ao-sheet__hero-fiat {
  margin-top: 6px;
  font-size: 14px;
  font-weight: 400;
  color: #64748b;
}

body:not(.light_theme) .agce-ao-sheet__hero-fiat {
  color: #94a3b8;
}

.agce-ao-sheet__kvlist {
  display: flex;
  flex-direction: column;
  gap: 0;
}

.agce-ao-sheet__kv {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  gap: 12px;
  padding: 10px 0;
  font-size: 16px;
}

.agce-ao-sheet__kv:last-child {
  border-bottom: none;
}

body:not(.light_theme) .agce-ao-sheet__kv {
  border-bottom-color: #1e293b;
}

.agce-ao-sheet__kv span:first-child {
  color: #94a3b8;
  flex-shrink: 0;
}

body.light_theme .agce-ao-sheet__kv span:first-child {
  color: #64748b;
}

.agce-ao-sheet__kv-val {
  font-weight: 600;
  text-align: right;
  word-break: break-all;
  color: #f0f0f0;
}

body.light_theme .agce-ao-sheet__kv-val {
  color: #0f172a;
}

.agce-ao-sheet__kv-val--accent {
  font-weight: 700;
  font-size: 15px;
  color: #0f172a;
}

body:not(.light_theme) .agce-ao-sheet__kv-val--accent {
  color: #f8fafc;
}

.agce-ao-sheet__divider {
  height: 1px;
  background: #e5e7eb;
  margin: 12px 0 14px;
}

body:not(.light_theme) .agce-ao-sheet__divider {
  background: #334155;
}

.agce-ao-sheet__grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 10px;
}

.agce-ao-sheet__grid--2 {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.agce-ao-sheet__pill {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 44px;
  padding: 10px 8px;
  border: none;
  border-radius: 10px;
  background: #f3f4f6;
  color: #0f172a;
  font-size: 13px;
  font-weight: 600;
  text-align: center;
  text-decoration: none;
  cursor: pointer;
  transition: background 0.15s ease, opacity 0.15s ease;
}

.agce-ao-sheet__pill:hover {
  background: #e5e7eb;
  color: #0f172a;
}

body:not(.light_theme) .agce-ao-sheet__pill {
  background: #1e293b;
  color: #f8fafc;
}

body:not(.light_theme) .agce-ao-sheet__pill:hover {
  background: #334155;
  color: #f8fafc;
}

.agce-ao-sheet__pill--primary {
  background: #e5e7eb;
}

body:not(.light_theme) .agce-ao-sheet__pill--primary {
  background: #d1aa67;
  color: #0f172a;
}

body:not(.light_theme) .agce-ao-sheet__pill--primary:hover {
  background: #be9856;
  color: #0f172a;
}

/* Sheet actions = same links as desktop table row (WalletPage renderActionButtons / Overview Transfer+Trade) */
.agce-ao-sheet__table-actions {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(104px, 1fr));
  gap: 10px;
}

.agce-ao-sheet__table-actions--spot {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}

.agce-ao-sheet__table-actions .btn-link,
.agce-ao-sheet__table-actions .funding-account__action,
.agce-ao-sheet__table-actions .funding-account__action--btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 44px;
  padding: 10px 12px;
  margin: 0;
  border: none;
  border-radius: 10px;
  background: #f3f4f6;
  font-size: 15px;
  font-weight: 500;
  text-decoration: none !important;
  text-align: center;
  cursor: pointer;
  box-sizing: border-box;
  color: #0f172a !important;
}

/* .agce-ao-sheet__table-actions .btn-link.text-success {
  color: #15803d !important;
} */

body:not(.light_theme) .agce-ao-sheet__table-actions .btn-link,
body:not(.light_theme) .agce-ao-sheet__table-actions .funding-account__action,
body:not(.light_theme) .agce-ao-sheet__table-actions .funding-account__action--btn {
  background: #1e293b;
  color: #f8fafc !important;
}

body:not(.light_theme) .agce-ao-sheet__table-actions .btn-link.text-success {
  color: #fff !important;
}

.agce-ao-mobile-total-with-more .agce-ao-balance-stack,
.agce-ao-mobile-total-with-more .agce-ao-account-amount-stack {
  min-width: 0;
}


td.ta-r.agce-ao-total-balance-cell.asstes_tdfirst .funding-account__subnum {
  text-align: left;
}

td.ta-r.agce-ao-total-balance-cell.asstes_tdfirst .funding-account__num {
  text-align: left;
}


@media (max-width: 991px) {

  td.ta-r.agce-ao-total-balance-cell.asstes_tdfirst .d-flex.justify-content-start.gap-2.agce-ao-mobile-total-with-more {
    justify-content: right !important;
  }

  td.ta-r.agce-ao-total-balance-cell.asstes_tdfirst .funding-account__num {
    text-align: right;
  }

  td.ta-r.agce-ao-total-balance-cell.asstes_tdfirst .funding-account__subnum {
    text-align: right;
  }

}

@media (max-width: 767.98px) {

  .agce-ao-sheet__fullname {
    font-size: 12px;
  }

  .agce-ao-sheet__sym {
    font-size: 15px;
  }

  .agce-ao-sheet__kv {
    font-size: 14px;
  }

  .agce-ao-sheet__coin {
    width: 32px;
    min-width: 32px;
    height: 32px;
  }

  .agce-ao-sheet__hero-num {
    font-size: 22px;
  }

  .agce-ao-sheet-dialog .modal-content.agce-ao-sheet {
    border-radius: 16px 16px 0 0;
  }

  .agce-ao-more-btn {
    padding: 0px;
  }

  .agce-ao-sheet__table-actions .btn-link,
  .agce-ao-sheet__table-actions .funding-account__action,
  .agce-ao-sheet__table-actions .funding-account__action--btn {
    min-height: 38px;
    padding: 8px 12px;
    font-size: 13px;
  }



}`, "",{"version":3,"sources":["webpack://./src/ui/Pages/AssetOverview/assetOverview.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,gCAAgC;EAChC,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,8BAA8B;EAC9B,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA,sGAAsG;AACtG;;EAEE;;IAEE,wBAAwB;EAC1B;;EAEA,gGAAgG;EAChG;;;;;;;;IAQE,aAAa;EACf;;EAEA,8BAA8B;EAC9B;;;;IAIE,aAAa;EACf;;EAEA,sCAAsC;EACtC;IACE,gBAAgB;IAChB,iCAAiC;EACnC;;EAEA;IACE,yBAAyB;IACzB,WAAW;IACX,oCAAoC;IACpC,4BAA4B;EAC9B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,mCAAmC;EACrC;;EAEA;IACE,6BAA6B;IAC7B,kCAAkC;IAClC,uBAAuB;IACvB,2BAA2B;IAC3B,2BAA2B;IAC3B,2BAA2B;EAC7B;;EAEA;IACE,8BAA8B;IAC9B,sBAAsB;IACtB,4BAA4B;IAC5B,2BAA2B;EAC7B;;EAEA;IACE,wBAAwB;IACxB,wBAAwB;EAC1B;;EAEA;;IAEE,wBAAwB;EAC1B;AACF;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,yBAAyB;EACzB,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,oCAAoC;EACpC,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,qBAAqB;EACrB,8EAA8E;AAChF;;AAEA;EACE,2EAA2E;AAC7E;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,yCAAyC;AAC3C;;AAEA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;AACF;;AAEA,mDAAmD;AACnD;EACE,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,SAAS;EACT,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,SAAS;EACT,eAAe;EACf,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,uBAAuB;EACvB,0FAA0F;AAC5F;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,OAAO;EACP,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,8CAA8C;EAC9C,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,WAAW;EACX,SAAS;EACT,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,uBAAuB;EACvB,cAAc;EACd,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,gCAAgC;EAChC,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,SAAS;EACT,eAAe;EACf,uBAAuB;EACvB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,UAAU;EACV,2GAA2G;EAC3G,SAAS;EACT,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;;;GAGG;;AAEH;EACE,iBAAiB;EACjB,yBAAyB;EACzB,gBAAgB;EAChB,8CAA8C;AAChD;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,aAAa;EACb,eAAe;EACf,YAAY;EACZ,uBAAuB;EACvB,cAAc;AAChB;;AAEA,oDAAoD;AACpD;EACE,6BAA6B;EAC7B,uDAAuD;AACzD;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;IAC3B,YAAY;EACd;;EAEA;IACE,UAAU;IACV,wBAAwB;IACxB,gBAAgB;EAClB;AACF;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,cAAc;EACd,yBAAiB;UAAjB,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;EACd,oBAAoB;EACpB,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,yBAAyB;EACzB,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,yBAAyB;EACzB,QAAQ;AACV;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,yBAAyB;EACzB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,SAAS;EACT,uBAAuB;EACvB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,qBAAqB;EACrB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE;;IAEE,kBAAkB;IAClB,mBAAmB;EACrB;AACF;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;yDACyD;;AAEzD;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,qBAAqB;EACrB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;;AAGA;;;EAGE;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;AAEF;;AAEA;;EAEE;IACE,kBAAkB;IAClB,kBAAkB;EACpB;;AAEF;;AAEA;;;EAGE;IACE,0BAA0B;EAC5B;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,iBAAiB;IACjB,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;EACpB;;AAEF;;AAEA;;EAEE;IACE,oCAAoC;IACpC,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;EAClB;;AAEF;;;AAGA;;EAEE;IACE,eAAe;IACf,YAAY;IACZ,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;;EAGA;IACE,aAAa;EACf;;;EAGA;IACE,gBAAgB;IAChB,gDAAgD;EAClD;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;AAEF;;AAEA,wGAAwG;AACxG;EACE,oBAAoB;AACtB;;AAEA;EACE,SAAS;EACT,uBAAuB;EACvB,UAAU;EACV,SAAS;EACT,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,cAAc;EACd,cAAc;EACd,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,2CAA2C;EAC3C,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,eAAe;;AAEjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,SAAO;EACP,YAAY;AACd;;AAEA,0FAA0F;AAC1F;EACE,oBAAoB;EACpB,sBAAsB;EACtB,qBAAqB;EACrB,QAAQ;EACR,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE;IACE,cAAc;EAChB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;;;AAIA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA,2FAA2F;AAC3F;EACE,mBAAmB;EACnB,uBAAuB;EACvB,yCAAyC;AAC3C;;AAEA,qDAAqD;AACrD;EACE,mBAAmB;EACnB,uBAAuB;EACvB,yCAAyC;EACzC,6CAA6C;EAC7C,kCAA0B;UAA1B,0BAA0B;AAC5B;;AAEA;EACE,mDAAmD;AACrD;;AAEA;EACE;IACE,qBAAqB;IACrB,uBAAuB;IACvB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;EACnB;;;EAGA;IACE,sBAAsB;EACxB;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA,wCAAwC;AACxC;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,8CAA8C;EAC9C,8DAA8D;AAChE;;AAEA;EACE,8DAA8D;EAC9D,qBAAqB;EACrB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,2CAA2C;AAC7C;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,2CAA2C;AAC7C;;AAEA;EACE;IACE,SAAS;IACT,eAAe;IACf,WAAW;IACX,gBAAgB;IAChB,YAAY;IACZ,aAAa;IACb,qBAAqB;IACrB,UAAU;EACZ;;EAEA;IACE,mBAAmB;IACnB,4BAA4B;IAC5B,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,4EAA4E;IAC5E,gEAAgE;EAClE;;EAEA;IACE,+GAA+G;EACjH;;EAEA;IACE,gBAAgB;IAChB,iCAAiC;EACnC;AACF;;AAEA;EACE;IACE,UAAU;IACV,sCAAsC;EACxC;;EAEA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;;AAEA;EACE;IACE,2BAA2B;EAC7B;;EAEA;IACE,wBAAwB;EAC1B;AACF;;AAEA;;EAEE;;;;;;IAME,0BAA0B;EAC5B;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,uBAAuB;EACvB,gCAAgC;AAClC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qDAAqD;EACrD,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,8BAA8B;EAC9B,aAAa;AACf;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,MAAM;AACR;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,qBAAqB;EACrB,SAAS;EACT,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,eAAe;EACf,qDAAqD;AACvD;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,+GAA+G;AAC/G;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,gDAAgD;AAClD;;AAEA;;;EAGE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;EAClB,SAAS;EACT,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,kBAAkB;EAClB,eAAe;EACf,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;;GAEG;;AAEH;;;EAGE,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;;EAEE,YAAY;AACd;;;AAGA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;;AAGA;;EAEE;IACE,iCAAiC;EACnC;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;AAEF;;AAEA;;EAEE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,eAAe;IACf,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,YAAY;EACd;;EAEA;;;IAGE,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;EACjB;;;;AAIF","sourcesContent":[".assets_overview_title {\n  font-size: 40px;\n  font-weight: 600;\n  margin: 6px 0 0px;\n  color: #0f172a;\n  border-bottom: 1px solid #E5E7EB;\n  padding-bottom: 15px;\n}\n\n.assets_overview_bl_inner {\n  display: grid;\n  grid-template-columns: 1fr 320px;\n  gap: 18px;\n  align-items: start;\n}\n\n.assets_overview_bl_inner_rgt {\n  min-width: 334px;\n  border-left: 1px solid #E5E7EB;\n  padding-left: 24px;\n  padding-top: 28px;\n  padding-right: 24px;\n  color: #0f172a;\n}\n\n.assets_overview_bl_inner_lft {\n  padding-top: 28px;\n}\n\n@media (max-width: 991.98px) {\n  .assets_overview_bl_inner {\n    grid-template-columns: 1fr;\n  }\n}\n\n/* Mobile + tablet (< lg): 2 columns only — Coin + Total Balance; more btn after price; thead hidden */\n@media (max-width: 991.98px) {\n\n  .dashboard_summary .desktop_view-2 table thead,\n  .dashboard_summary.account_table table thead {\n    display: none !important;\n  }\n\n  /* Crypto — same column order as spot / funding wallet (Coin + Total on mobile): hide cols 3–6 */\n  .dashboard_summary .desktop_view-2 table thead th:nth-child(3),\n  .dashboard_summary .desktop_view-2 table thead th:nth-child(4),\n  .dashboard_summary .desktop_view-2 table thead th:nth-child(5),\n  .dashboard_summary .desktop_view-2 table thead th:nth-child(6),\n  .dashboard_summary .desktop_view-2 table tbody td:nth-child(3),\n  .dashboard_summary .desktop_view-2 table tbody td:nth-child(4),\n  .dashboard_summary .desktop_view-2 table tbody td:nth-child(5),\n  .dashboard_summary .desktop_view-2 table tbody td:nth-child(6) {\n    display: none;\n  }\n\n  /* Account: Account + Amount */\n  .dashboard_summary.account_table table thead th:nth-child(3),\n  .dashboard_summary.account_table table thead th:nth-child(4),\n  .dashboard_summary.account_table table tbody td:nth-child(3),\n  .dashboard_summary.account_table table tbody td:nth-child(4) {\n    display: none;\n  }\n\n  /* Wallet /spot: Coin + Total Amount */\n  .dashboard_right.funding-account.wallet-page--ao-popup .funding-account__tablewrap {\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n  }\n\n  .dashboard_right.funding-account.wallet-page--ao-popup .funding-account__table {\n    display: table !important;\n    width: 100%;\n    border-collapse: collapse !important;\n    border-spacing: 0 !important;\n  }\n\n  .dashboard_right.funding-account.wallet-page--ao-popup .funding-account__table thead {\n    display: none !important;\n  }\n\n  .dashboard_right.funding-account.wallet-page--ao-popup .funding-account__table tbody {\n    display: table-row-group !important;\n  }\n\n  .dashboard_right.funding-account.wallet-page--ao-popup .funding-account__table tbody tr {\n    display: table-row !important;\n    background: transparent !important;\n    border: none !important;\n    border-radius: 0 !important;\n    box-shadow: none !important;\n    margin-bottom: 0 !important;\n  }\n\n  .dashboard_right.funding-account.wallet-page--ao-popup .funding-account__table tbody td {\n    display: table-cell !important;\n    vertical-align: middle;\n    padding: 10px 2px !important;\n    border-top: none !important;\n  }\n\n  .dashboard_right.funding-account.wallet-page--ao-popup .funding-account__table tbody td[data-label]::before {\n    display: none !important;\n    content: none !important;\n  }\n\n  .dashboard_right.funding-account.wallet-page--ao-popup .funding-account__table thead th:nth-child(n+3),\n  .dashboard_right.funding-account.wallet-page--ao-popup .funding-account__table tbody td:nth-child(n+3) {\n    display: none !important;\n  }\n}\n\n.agce-ao-more-btn {\n  border: none;\n  background: transparent;\n  padding: 6px;\n  line-height: 1;\n  cursor: pointer;\n  color: inherit;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.agce-ao-more-btn .ri-more-2-fill {\n  font-size: 1.35rem;\n  vertical-align: middle;\n}\n\nbody.light_theme .agce-ao-more-btn {\n  color: #0f172a;\n}\n\n.agce-ao-est-donutwrap {\n  flex: 0 0 auto;\n  display: inline-flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 12px;\n  margin-left: 12px;\n}\n\n.agce-ao-est-donut {\n  flex: 0 0 auto;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 124px;\n  height: 124px;\n}\n\n.agce-ao-donut {\n  display: block;\n}\n\n.agce-ao-donut-legend {\n  min-width: 150px;\n  max-width: 220px;\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.agce-ao-donut-legend__row {\n  display: grid;\n  grid-template-columns: 10px 1fr auto;\n  align-items: center;\n  gap: 8px;\n  font-size: 12px;\n  line-height: 1.2;\n  color: #e2e8f0;\n  opacity: 0.95;\n}\n\nbody.light_theme .agce-ao-donut-legend__row {\n  color: #0f172a;\n}\n\n.agce-ao-donut-legend__dot {\n  width: 10px;\n  height: 10px;\n  border-radius: 999px;\n  display: inline-block;\n  box-shadow: 0 0 0 1px rgba(255, 255, 255, 0.12), 0 2px 6px rgba(0, 0, 0, 0.35);\n}\n\nbody.light_theme .agce-ao-donut-legend__dot {\n  box-shadow: 0 0 0 1px rgba(15, 23, 42, 0.16), 0 2px 6px rgba(0, 0, 0, 0.15);\n}\n\n.agce-ao-donut-legend__label {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.agce-ao-donut-legend__value {\n  font-variant-numeric: tabular-nums;\n  color: #94a3b8;\n}\n\nbody.light_theme .agce-ao-donut-legend__value {\n  color: #475569;\n}\n\n.agce-ao-donut-legend__empty {\n  font-size: 12px;\n  color: #94a3b8;\n}\n\n.agce-ao-detail-backdrop {\n  position: fixed;\n  inset: 0;\n  z-index: 1055;\n  animation: ao-fade-in 160ms ease-out both;\n}\n\n@keyframes ao-fade-in {\n  from {\n    opacity: 0;\n  }\n\n  to {\n    opacity: 1;\n  }\n}\n\n/* Row popup: label left, value right (same line) */\n.agce-ao-detail-list {\n  margin: 0;\n}\n\n.agce-ao-detail-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  gap: 12px;\n  padding: 12px 0;\n}\n\n.agce-ao-detail-row:last-of-type {\n  border-bottom: none;\n  padding-bottom: 0;\n}\n\n.agce-ao-detail-row:first-of-type {\n  padding-top: 0;\n}\n\n.agce-ao-est-donut feDropShadow {\n  flood-color: aliceblue;\n}\n\n.estimated_balance .wallet-title {\n  margin: 10px 0px 10px;\n}\n\n.agce-ao-detail-row dt {\n  flex: 0 1 auto;\n  max-width: 48%;\n  margin: 0;\n  font-weight: 400;\n  color: #000000;\n  font-size: 14px;\n  line-height: 1.35;\n}\n\n.agce-ao-detail-row dd {\n  flex: 0 1 auto;\n  margin: 0;\n  text-align: right;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 1.35;\n  color: #f1f5f9;\n  max-width: 52%;\n}\n\nbody.light_theme .agce-ao-detail-row dd {\n  color: #0f172a;\n}\n\n.agce-ao-detail-value {\n  display: block;\n}\n\n.agce-ao-detail-sub {\n  display: block;\n  margin-top: 4px;\n  font-size: 12px;\n  font-weight: 400;\n  color: #94a3b8;\n}\n\n.agce-ao-detail-actions {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  padding-top: 16px;\n  margin-top: 0px;\n}\n\n.agce-ao-detail-actions-label {\n  flex: 0 0 auto;\n  margin: 0;\n  font-size: 14px;\n  /* font-weight: 500; */\n  color: #0c0c0c;\n}\n\n.modal-dialog .agce-ao-detail-actions .btn-sm {\n  color: #000;\n}\n\n.agce-ao-detail-actions-btns {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n  justify-content: flex-end;\n  align-items: center;\n  flex: 1 1 auto;\n  min-width: 0;\n}\n\nbody.light_theme .agce-ao-detail-actions {\n  border-top-color: #e5e7eb;\n}\n\n/* Left column */\n.agce-assets {\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n}\n\n.agce-assets__topcard {\n  border: 1px solid #E5E7EB;\n  border-radius: 16px;\n  padding: 16px 16px 14px;\n  background: linear-gradient(90deg, rgba(252, 253, 255, 1) 0%, rgba(242, 248, 255, 1) 100%);\n}\n\n.agce-assets__topcard-head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n}\n\n.agce-assets__topcard-meta {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.agce-assets__label {\n  font-size: 12px;\n  font-weight: 400;\n  color: #64748b;\n  letter-spacing: -0.15px;\n}\n\n.agce-assets__chip {\n  border: 1px solid #D1D5DC;\n  background: #F3F4F6;\n  border-radius: 10px;\n  padding: 4px 10px;\n  font-size: 12px;\n  font-weight: 600;\n  color: #0f172a;\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.agce-assets__select {\n  position: relative;\n  display: inline-flex;\n}\n\n.agce-assets__menu {\n  position: absolute;\n  top: calc(100% + 8px);\n  left: 0;\n  min-width: 140px;\n  background: #fff;\n  border: 1px solid #e5e7eb;\n  border-radius: 12px;\n  box-shadow: 0 16px 40px rgba(15, 23, 42, 0.12);\n  padding: 6px;\n  z-index: 50;\n}\n\n.agce-assets__menu-item {\n  width: 100%;\n  border: 0;\n  background: transparent;\n  padding: 10px 10px;\n  border-radius: 10px;\n  font-size: 12px;\n  font-weight: 700;\n  color: #0f172a;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  cursor: pointer;\n}\n\n.agce-assets__menu-item:hover {\n  background: #f1f5f9;\n}\n\n.agce-assets__menu-item.is-active {\n  background: #eef2f7;\n}\n\n.agce-assets__menu-item i {\n  font-size: 16px;\n  color: #16a34a;\n}\n\n.agce-assets__iconbtn {\n  border: 0;\n  background: transparent;\n  color: #94a3b8;\n  padding: 6px;\n  border-radius: 10px;\n  cursor: pointer;\n}\n\n.agce-assets__iconbtn:hover {\n  background: #f1f5f9;\n  color: #475569;\n}\n\n.agce-assets__topcard-main {\n  margin-top: 10px;\n}\n\n.agce-assets__amount {\n  display: flex;\n  align-items: baseline;\n  gap: 8px;\n}\n\n.agce-assets__amount-num {\n  font-size: 48px;\n  font-weight: 700;\n  letter-spacing: -0.04em;\n  line-height: 1;\n}\n\n.agce-assets__amount-unit {\n  font-size: 24px;\n  font-weight: 400;\n  color: #94a3b8;\n  text-transform: uppercase;\n  letter-spacing: 0.03em;\n}\n\n.agce-assets__subrow {\n  margin-top: 8px;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 12px;\n  font-weight: 400;\n}\n\n.agce-assets__muted {\n  color: #94a3b8;\n}\n\n.agce-assets__pnl {\n  color: #16a34a;\n}\n\n.agce-assets__panel {\n  background: #ffffff;\n  border: 1px solid #EDEFF2;\n  border-radius: 14px;\n  overflow: hidden;\n}\n\n.agce-assets__panel-head {\n  padding: 18px 16px 14px;\n  border-bottom: 1px solid #eef2f7;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n}\n\n.agce-assets__panel-title {\n  margin: 0;\n  font-size: 18px;\n  letter-spacing: -0.20px;\n  color: #303236;\n  font-weight: 500;\n}\n\n.agce-assets__panel-tools {\n  display: inline-flex;\n  align-items: center;\n  gap: 12px;\n  flex: 0 0 auto;\n}\n\n.agce-assets__panel-search {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 0;\n  transition: padding 240ms ease, border-color 240ms ease, background-color 240ms ease, box-shadow 240ms ease;\n  border: 0;\n  border-radius: 10px;\n  background: transparent;\n  color: #64748b;\n}\n\n.agce-assets__panel-searchbtn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 34px;\n  height: 34px;\n  border-radius: 10px;\n  border: 1px solid #e5e7eb;\n  background: #fff;\n  color: #64748b;\n  cursor: pointer;\n}\n\n/* .agce-assets__panel-searchbtn:hover {\n  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.12);\n  border-color: #cbd5e1;\n} */\n\n.agce-assets__panel-search.is-open {\n  padding: 2px 10px;\n  border: 1px solid #e5e7eb;\n  background: #fff;\n  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.10);\n}\n\n.agce-assets__panel-search.is-open .agce-assets__panel-searchbtn {\n  border: none;\n}\n\n.agcx-assets__panel-search.is-open .agcx-assets__panel-searchbtn:hover {\n  box-shadow: none;\n}\n\n.agcx-assets__panel-search input {\n  border: 0;\n  outline: none;\n  font-size: 13px;\n  width: 160px;\n  background: transparent;\n  color: #0f172a;\n}\n\n/* Smooth expand animation (input mounts on click) */\n.agcx-assets__panel-search.is-open input {\n  transform-origin: left center;\n  animation: agcx-panel-search-expand 240ms ease-out both;\n}\n\n@keyframes agcx-panel-search-expand {\n  from {\n    opacity: 0;\n    transform: translateX(-6px);\n    max-width: 0;\n  }\n\n  to {\n    opacity: 1;\n    transform: translateX(0);\n    max-width: 160px;\n  }\n}\n\n.agcx-assets__panel-hide0 {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 13px;\n  color: #475569;\n  user-select: none;\n  margin: 0;\n}\n\n.assets_overview_bl {\n  padding-left: 35px;\n  padding-right: 36px;\n}\n\n.agcx-assets__table {\n  width: 100%;\n  overflow-x: auto;\n  min-height: 460px;\n}\n\n.agcx-assets__table-el {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.agcx-assets__table-el thead th {\n  padding: 12px 16px;\n  font-size: 12px;\n  font-weight: 500;\n  letter-spacing: -0.15px;\n  color: #94a3b8;\n  text-transform: none;\n  border-bottom: 1px solid #eef2f7;\n  white-space: nowrap;\n}\n\n.agcx-assets__table-el tbody td {\n  padding: 14px 16px;\n  border-top: 1px solid #f1f5f9;\n  vertical-align: middle;\n}\n\n.agcx-assets__coin {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  min-width: 0;\n}\n\n.agcx-assets__coin-icon {\n  width: 40px;\n  height: 40px;\n  border-radius: 999px;\n  /* background: #f8fafc; */\n  /* border: 1px solid #eef2f7; */\n  display: grid;\n  place-items: center;\n  overflow: hidden;\n  flex: 0 0 auto;\n}\n\n.agce-assets__coin-icon img {\n  width: 32px;\n  height: 32px;\n  object-fit: contain;\n}\n\n.agce-assets__coin-text {\n  min-width: 0;\n}\n\n.agce-assets__coin-sym {\n  font-size: 15px;\n  font-weight: 600;\n  /* color: #0f172a; */\n  line-height: 1.1;\n}\n\n.agce-assets__coin-name {\n  font-size: 12px;\n  color: #94a3b8;\n  font-weight: 400;\n  letter-spacing: -0.15px;\n}\n\n.agce-assets__right {\n  text-align: right;\n}\n\n.agce-assets__price {\n  font-size: 14px;\n  font-weight: 600;\n}\n\ntd.agce-assets__right.agce-assets__chg.is-up {\n  text-align: right;\n  width: 100%;\n}\n\n.agce-assets__chg {\n  font-size: 12px;\n  font-weight: 400;\n  display: inline-flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 6px;\n}\n\n.agce-assets__chg.is-up {\n  color: #16a34a;\n}\n\n.agce-assets__chg.is-down {\n  color: #dc2626;\n  text-align: right;\n  width: 100%;\n}\n\n.agce-assets__chg-icon i {\n  font-size: 14px;\n}\n\n.agce-assets__more {\n  border: 0;\n  background: transparent;\n  color: #94a3b8;\n  cursor: pointer;\n  padding: 6px;\n  border-radius: 10px;\n}\n\n.agce-assets__more:hover {\n  background: #f1f5f9;\n  color: #475569;\n}\n\n.agce-assets__more-actions {\n  display: inline-flex;\n  justify-content: flex-end;\n  align-items: center;\n  gap: 10px;\n}\n\n.agce-assets__actionbtn {\n  border: 0;\n  background: transparent;\n  color: #0f172a;\n  font-weight: 600;\n  font-size: 13px;\n  padding: 6px 8px;\n  border-radius: 10px;\n  cursor: pointer;\n  text-decoration: none;\n  display: inline-flex;\n  align-items: center;\n}\n\n.agce-assets__actionbtn:hover {\n  background: #f1f5f9;\n}\n\n.agce-assets__actionbtn--ghost {\n  color: #0f172a;\n}\n\n.agce-assets__actionbtn--ghost:hover {\n  background: #f1f5f9;\n}\n\n@media (max-width: 767.98px) {\n\n  .agce-assets__table-el thead th,\n  .agce-assets__table-el tbody td {\n    padding-left: 12px;\n    padding-right: 12px;\n  }\n}\n\n/* Right column */\n.agce-assets-side {\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n  padding-right: 0px;\n  width: 100%;\n}\n\n.agce-assets-side__card {\n  background: #ffffff;\n}\n\n.agce-assets-side__card--market {\n  background: #F1F6FF;\n  border: 1px solid #BEDBFF;\n  padding: 18px;\n  border-radius: 18px;\n}\n\n.agce-assets-side__card-title {\n  font-size: 14px;\n  font-weight: 500;\n  margin-bottom: 10px;\n}\n\n.agce-assets-side__actions {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.agce-assets-side__action {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n  position: relative;\n  text-decoration: none;\n  padding: 16px;\n  border-radius: 12px;\n  border: 1px solid #eef2f7;\n  background: #ffffff;\n  color: inherit;\n}\n\n.agce-assets-side__action i.ri-arrow-right-s-line {\n  position: absolute;\n  right: 16px;\n  top: 50%;\n  transform: translateY(-50%);\n}\n\n.agce-assets-side__action-text {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  min-width: 0;\n}\n\n.agce-assets-side__action-h {\n  font-size: 15px;\n  font-weight: 600;\n  /* color: #0f172a; */\n  letter-spacing: -0.32px;\n}\n\n.agce-assets-side__action-p {\n  font-size: 12px;\n  font-weight: 500;\n  line-height: 1.35;\n  opacity: 0.9;\n}\n\n.agce-assets-side__action--deposit {\n  background: #FFF6E8;\n  border-color: #FFF6E8;\n}\n\n/* .agce-assets-side__action--buy{ background: #eaf8f0; }\n.agce-assets-side__action--fiat{ background: #fff1f2; } */\n\n.agce-assets-side__rowhead {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n}\n\n.agce-assets-side__morelink {\n  font-size: 11px;\n  font-weight: 500;\n  color: #D1AA67;\n  text-decoration: none;\n}\n\n.agce-assets-side__morelink:hover {\n  color: #475569;\n  text-decoration: underline;\n}\n\n.agce-assets-side__empty {\n  border: 1px solid #E5E7EB;\n  border-radius: 12px;\n  padding: 42px 14px;\n  display: grid;\n  justify-items: center;\n  gap: 8px;\n}\n\n.agce-assets-side__empty-icon {\n  width: 54px;\n  height: 54px;\n  border-radius: 50px;\n  background: #F3F4F6;\n  border: none;\n  display: grid;\n  place-items: center;\n  color: #94a3b8;\n  font-size: 22px;\n}\n\n.agce-assets-side__empty-text {\n  font-size: 14px;\n  color: #4A5565;\n  font-weight: 500;\n  margin: 5px 0px 2px;\n}\n\n.agce-assets-side__pill {\n  font-size: 10px;\n  font-weight: 500;\n  padding: 5px 10px;\n  border-radius: 999px;\n  background: #DCFCE7;\n  color: #008236;\n  border: 1px solid #B9F8CF;\n}\n\n.agce-assets-side__market-value {\n  font-size: 24px;\n  font-weight: 700;\n  color: #0f172a;\n  letter-spacing: -0.02em;\n  margin-bottom: 2px;\n}\n\n.agce-assets-side__market-sub {\n  font-size: 12px;\n  font-weight: 500;\n  color: #008236;\n}\n\n.agce-assets-side__action:hover {\n  color: #000;\n}\n\n\n@media (max-width: 1440px) {\n\n\n  .assets_overview_title {\n    font-size: 36px;\n  }\n\n  .agce-assets-side__empty {\n    padding: 18px 14px;\n  }\n\n  .assets_overview_bl {\n    padding-left: 22px;\n    padding-right: 20px;\n  }\n\n}\n\n@media (max-width: 1366px) {\n\n  .assets_overview_bl {\n    padding-left: 10px;\n    padding-right: 0px;\n  }\n\n}\n\n@media (max-width: 1024px) {\n\n\n  .assets_overview_bl_inner {\n    grid-template-columns: 1fr;\n  }\n\n  .assets_overview_title {\n    font-size: 26px;\n  }\n\n  .agce-assets-side__action {\n    justify-content: start;\n  }\n\n  .assets_overview_bl_inner_rgt {\n    padding-left: 0px;\n    border-left: none;\n    padding-top: 15px;\n    padding-right: 0px;\n  }\n\n}\n\n@media (max-width: 991px) {\n\n  .d-flex.align-items-center.justify-content-start.gap-2.agce-ao-mobile-total-with-more {\n    justify-content: flex-end !important;\n    text-align: right;\n  }\n\n  .modal {\n    align-items: end;\n  }\n\n}\n\n\n@media (max-width: 767px) {\n\n  .assets_overview_title {\n    font-size: 20px;\n    border: none;\n    padding-bottom: 5px;\n  }\n\n  .agce-ao-balance-stack {\n    white-space: nowrap;\n  }\n\n\n  .modal-content.agce-ao-sheet .agce-ao-sheet__divider {\n    display: none;\n  }\n\n\n  .modal-content.agce-ao-sheet .agce-ao-sheet__table-actions {\n    margin-top: 20px;\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n\n  .assets_overview_bl_inner_lft {\n    padding-top: 10px;\n  }\n\n  .agce-ao-sheet__kv {\n    font-size: 14px;\n  }\n\n  .agce-assets__coin-sym {\n    font-size: 12px;\n  }\n\n  .agce-assets__coin-name {\n    font-size: 10px;\n  }\n\n  .agce-assets__table-el tbody td {\n    padding: 10px 9px;\n    font-size: 12px;\n  }\n\n  .assets_overview_bl {\n    padding-left: 0px;\n  }\n\n  .agcx-assets__amount-num {\n    font-size: 36px;\n  }\n\n  .agcx-assets__amount-unit {\n    font-size: 18px;\n  }\n\n}\n\n/* Asset Overview: icon-only until `.search_active`; expand width smoothly after click (see index.js). */\n.dashboard_listing_section.Overview_mid .market_section .coin_right .searchBar.custom-tabs {\n  transition: 0.5s all;\n}\n\n.dashboard_listing_section.Overview_mid .market_section .coin_right .agcx-assets-search__trigger {\n  border: 0;\n  background: transparent;\n  padding: 0;\n  margin: 0;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  color: inherit;\n  flex-shrink: 0;\n  width: 100%;\n  min-height: 22px;\n}\n\n.dashboard_listing_section.Overview_mid .market_section .coin_right .agcx-assets-search__trigger:focus-visible {\n  outline: 2px solid rgba(252, 213, 53, 0.85);\n  outline-offset: 2px;\n  border-radius: 8px;\n}\n\n.dashboard_listing_section.Overview_mid .market_section .coin_right .agcx-assets-search__trigger i {\n  font-size: 18px;\n  line-height: 1;\n}\n\n.dashboard_listing_section.Overview_mid .market_section .coin_right .searchBar.custom-tabs.search_active {\n  width: 280px;\n  max-width: 100%;\n\n}\n\n.dashboard_listing_section.Overview_mid .market_section .coin_right .searchBar.custom-tabs.search_active .agcx-assets-search__trigger {\n  width: auto;\n}\n\n.dashboard_listing_section.Overview_mid .market_section .coin_right .searchBar.custom-tabs.search_active .custom_search {\n  display: block !important;\n  flex: 1;\n  min-width: 0;\n}\n\n/* Mobile row: total column shows main balance + fiat subline; desktop shows number only */\n.agcx-ao-balance-stack {\n  display: inline-flex;\n  flex-direction: column;\n  align-items: flex-end;\n  gap: 2px;\n  text-align: right;\n}\n\n.agcx-ao-balance-stack__main {\n  font-weight: 600;\n  line-height: 1.2;\n}\n\n.agcx-ao-balance-stack__fiat {\n  display: none;\n  font-size: 12px;\n  font-weight: 400;\n  color: #64748b;\n  line-height: 1.2;\n}\n\n@media (max-width: 767.98px) {\n  .agcx-ao-balance-stack__fiat {\n    display: block;\n  }\n\n  .total_balance_text {\n    display: none;\n  }\n}\n\n.agcx-ao-account-amount-stack {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\ntd.ta-r.agcx-ao-total-balance-cell .funding-account__subnum {\n  text-align: left;\n}\n\ntd.ta-r.agcx-ao-total-balance-cell.asstes_tdfirst .agcx-ao-balance-stack {\n  align-items: start;\n  text-align: left;\n}\n\n\n\n.agcx-ao-account-amount-stack__main {\n  font-weight: 500;\n  line-height: 1.25;\n}\n\n.agcx-ao-account-amount-stack__fiat {\n  font-size: 12px;\n  font-weight: 400;\n  color: #64748b;\n}\n\n/* Row-detail overlay: d-flex (replaces d-block) so dialog + bottom sheet align correctly */\n.modal.agcx-ao-sheet-modal.d-flex {\n  align-items: center;\n  justify-content: center;\n  animation: ao-fade-in 160ms ease-out both;\n}\n\n/* Same overlay class used in JSX after agce rename */\n.modal.agce-ao-sheet-modal.d-flex {\n  align-items: center;\n  justify-content: center;\n  animation: ao-fade-in 160ms ease-out both;\n  background-color: rgb(0 0 0 / 40%) !important;\n  backdrop-filter: blur(5px);\n}\n\nbody.light_theme .modal.agce-ao-sheet-modal.d-flex {\n  background-color: rgb(255 255 255 / 20%) !important;\n}\n\n@media (max-width: 991.98px) {\n  .modal.agcx-ao-sheet-modal.d-flex {\n    align-items: flex-end;\n    justify-content: center;\n    padding-left: 0;\n    padding-right: 0;\n    padding-bottom: 0;\n  }\n\n\n  body .agcx-ao-sheet__table-actions .btn-link.text-success {\n    color: #000 !important;\n  }\n\n  .agcx-ao-balance-stack {\n    white-space: nowrap;\n  }\n}\n\n/* Bottom sheet–style row detail modal */\n.agcx-ao-sheet-dialog {\n  max-width: 520px;\n  margin: 1rem auto;\n}\n\n.agcx-ao-sheet.modal-content {\n  background: #ffffff;\n  color: #0f172a;\n  border-radius: 16px;\n  overflow: hidden;\n  box-shadow: 0 16px 48px rgba(15, 23, 42, 0.12);\n  animation: ao-pop-in 180ms cubic-bezier(0.2, 0.8, 0.2, 1) both;\n}\n\n.agce-ao-sheet.modal-content {\n  animation: ao-pop-in 180ms cubic-bezier(0.2, 0.8, 0.2, 1) both;\n  background: #1e202691;\n  color: #f0f0f0;\n  border-radius: 16px;\n  overflow: hidden;\n  box-shadow: 0 16px 48px rgba(0, 0, 0, 0.55);\n}\n\nbody.light_theme .agce-ao-sheet.modal-content {\n  background: #ffffff75;\n  color: #0f172a;\n  box-shadow: 0 16px 48px rgba(15, 23, 42, 0.12);\n}\n\nbody:not(.light_theme) .agcx-ao-sheet.modal-content {\n  background: #0f172a;\n  color: #f8fafc;\n  box-shadow: 0 16px 48px rgba(0, 0, 0, 0.45);\n}\n\n@media (max-width: 991.98px) {\n  .agcx-ao-sheet-dialog {\n    margin: 0;\n    max-width: 100%;\n    width: 100%;\n    min-height: auto;\n    height: auto;\n    display: flex;\n    align-items: flex-end;\n    padding: 0;\n  }\n\n  .agce-ao-sheet-dialog .modal-content.agce-ao-sheet {\n    border-radius: 16px;\n    max-height: min(92vh, 900px);\n    overflow: hidden;\n    display: flex;\n    flex-direction: column;\n    box-shadow: 0 24px 48px rgba(0, 0, 0, 0.55), 0 10px 24px rgba(0, 0, 0, 0.35);\n    animation: ao-sheet-up 220ms cubic-bezier(0.2, 0.8, 0.2, 1) both;\n  }\n\n  body.light_theme .agce-ao-sheet-dialog .modal-content.agce-ao-sheet {\n    box-shadow: inset 0 1px 0 rgb(246 246 246), 0 24px 48px rgba(15, 23, 42, 0.12), 0 10px 24px rgb(15 23 42 / 39%);\n  }\n\n  .agce-ao-sheet-dialog .agce-ao-sheet__body {\n    overflow-y: auto;\n    -webkit-overflow-scrolling: touch;\n  }\n}\n\n@keyframes ao-pop-in {\n  from {\n    opacity: 0;\n    transform: translateY(8px) scale(0.98);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateY(0) scale(1);\n  }\n}\n\n@keyframes ao-sheet-up {\n  from {\n    transform: translateY(18px);\n  }\n\n  to {\n    transform: translateY(0);\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n\n  .agce-ao-detail-backdrop,\n  .modal.agcx-ao-sheet-modal.d-flex,\n  .modal.agce-ao-sheet-modal.d-flex,\n  .agcx-ao-sheet.modal-content,\n  .agce-ao-sheet.modal-content,\n  .agce-ao-sheet-dialog .modal-content.agce-ao-sheet {\n    animation: none !important;\n  }\n}\n\n.agce-ao-sheet__header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 16px 16px 12px;\n  border-bottom: 1px solid #e5e7eb;\n}\n\nbody:not(.light_theme) .agce-ao-sheet__header {\n  border-bottom-color: #1e293b;\n}\n\n.agce-ao-sheet__brand {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  min-width: 0;\n}\n\n.agce-ao-sheet__coin {\n  width: 44px;\n  height: 44px;\n  border-radius: 50%;\n  object-fit: cover;\n  flex-shrink: 0;\n}\n\n.agce-ao-sheet__account-badge {\n  width: 44px;\n  height: 44px;\n  border-radius: 50%;\n  background: linear-gradient(135deg, #e2e8f0, #cbd5e1);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: 700;\n  font-size: 18px;\n  color: #0f172a;\n  flex-shrink: 0;\n}\n\n.agce-ao-sheet__sym {\n  font-size: 18px;\n  font-weight: 700;\n  line-height: 1.2;\n}\n\n.agce-ao-sheet__fullname {\n  font-size: 13px;\n  font-weight: 400;\n  color: #64748b;\n  margin-top: 2px;\n  line-height: 1.25;\n}\n\nbody:not(.light_theme) .agce-ao-sheet__fullname {\n  color: #94a3b8;\n}\n\n.agce-ao-sheet__close {\n  flex-shrink: 0;\n}\n\nbody:not(.light_theme) .agce-ao-sheet__close {\n  filter: invert(1) grayscale(1);\n  opacity: 0.85;\n}\n\n.agce-ao-sheet__body {\n  padding: 16px 16px 20px;\n}\n\n.agce-ao-sheet__hero {\n  margin-bottom: 12px;\n}\n\n.agce-ao-sheet__hero-num {\n  font-size: 28px;\n  font-weight: 700;\n  letter-spacing: -0.02em;\n  line-height: 1.15;\n  word-break: break-all;\n}\n\n.agce-ao-sheet__hero-fiat {\n  margin-top: 6px;\n  font-size: 14px;\n  font-weight: 400;\n  color: #64748b;\n}\n\nbody:not(.light_theme) .agce-ao-sheet__hero-fiat {\n  color: #94a3b8;\n}\n\n.agce-ao-sheet__kvlist {\n  display: flex;\n  flex-direction: column;\n  gap: 0;\n}\n\n.agce-ao-sheet__kv {\n  display: flex;\n  justify-content: space-between;\n  align-items: baseline;\n  gap: 12px;\n  padding: 10px 0;\n  font-size: 16px;\n}\n\n.agce-ao-sheet__kv:last-child {\n  border-bottom: none;\n}\n\nbody:not(.light_theme) .agce-ao-sheet__kv {\n  border-bottom-color: #1e293b;\n}\n\n.agce-ao-sheet__kv span:first-child {\n  color: #94a3b8;\n  flex-shrink: 0;\n}\n\nbody.light_theme .agce-ao-sheet__kv span:first-child {\n  color: #64748b;\n}\n\n.agce-ao-sheet__kv-val {\n  font-weight: 600;\n  text-align: right;\n  word-break: break-all;\n  color: #f0f0f0;\n}\n\nbody.light_theme .agce-ao-sheet__kv-val {\n  color: #0f172a;\n}\n\n.agce-ao-sheet__kv-val--accent {\n  font-weight: 700;\n  font-size: 15px;\n  color: #0f172a;\n}\n\nbody:not(.light_theme) .agce-ao-sheet__kv-val--accent {\n  color: #f8fafc;\n}\n\n.agce-ao-sheet__divider {\n  height: 1px;\n  background: #e5e7eb;\n  margin: 12px 0 14px;\n}\n\nbody:not(.light_theme) .agce-ao-sheet__divider {\n  background: #334155;\n}\n\n.agce-ao-sheet__grid {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 10px;\n}\n\n.agce-ao-sheet__grid--2 {\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n}\n\n.agce-ao-sheet__pill {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 44px;\n  padding: 10px 8px;\n  border: none;\n  border-radius: 10px;\n  background: #f3f4f6;\n  color: #0f172a;\n  font-size: 13px;\n  font-weight: 600;\n  text-align: center;\n  text-decoration: none;\n  cursor: pointer;\n  transition: background 0.15s ease, opacity 0.15s ease;\n}\n\n.agce-ao-sheet__pill:hover {\n  background: #e5e7eb;\n  color: #0f172a;\n}\n\nbody:not(.light_theme) .agce-ao-sheet__pill {\n  background: #1e293b;\n  color: #f8fafc;\n}\n\nbody:not(.light_theme) .agce-ao-sheet__pill:hover {\n  background: #334155;\n  color: #f8fafc;\n}\n\n.agce-ao-sheet__pill--primary {\n  background: #e5e7eb;\n}\n\nbody:not(.light_theme) .agce-ao-sheet__pill--primary {\n  background: #d1aa67;\n  color: #0f172a;\n}\n\nbody:not(.light_theme) .agce-ao-sheet__pill--primary:hover {\n  background: #be9856;\n  color: #0f172a;\n}\n\n/* Sheet actions = same links as desktop table row (WalletPage renderActionButtons / Overview Transfer+Trade) */\n.agce-ao-sheet__table-actions {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(104px, 1fr));\n  gap: 10px;\n}\n\n.agce-ao-sheet__table-actions--spot {\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n}\n\n.agce-ao-sheet__table-actions .btn-link,\n.agce-ao-sheet__table-actions .funding-account__action,\n.agce-ao-sheet__table-actions .funding-account__action--btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 44px;\n  padding: 10px 12px;\n  margin: 0;\n  border: none;\n  border-radius: 10px;\n  background: #f3f4f6;\n  font-size: 15px;\n  font-weight: 500;\n  text-decoration: none !important;\n  text-align: center;\n  cursor: pointer;\n  box-sizing: border-box;\n  color: #0f172a !important;\n}\n\n/* .agce-ao-sheet__table-actions .btn-link.text-success {\n  color: #15803d !important;\n} */\n\nbody:not(.light_theme) .agce-ao-sheet__table-actions .btn-link,\nbody:not(.light_theme) .agce-ao-sheet__table-actions .funding-account__action,\nbody:not(.light_theme) .agce-ao-sheet__table-actions .funding-account__action--btn {\n  background: #1e293b;\n  color: #f8fafc !important;\n}\n\nbody:not(.light_theme) .agce-ao-sheet__table-actions .btn-link.text-success {\n  color: #fff !important;\n}\n\n.agce-ao-mobile-total-with-more .agce-ao-balance-stack,\n.agce-ao-mobile-total-with-more .agce-ao-account-amount-stack {\n  min-width: 0;\n}\n\n\ntd.ta-r.agce-ao-total-balance-cell.asstes_tdfirst .funding-account__subnum {\n  text-align: left;\n}\n\ntd.ta-r.agce-ao-total-balance-cell.asstes_tdfirst .funding-account__num {\n  text-align: left;\n}\n\n\n@media (max-width: 991px) {\n\n  td.ta-r.agce-ao-total-balance-cell.asstes_tdfirst .d-flex.justify-content-start.gap-2.agce-ao-mobile-total-with-more {\n    justify-content: right !important;\n  }\n\n  td.ta-r.agce-ao-total-balance-cell.asstes_tdfirst .funding-account__num {\n    text-align: right;\n  }\n\n  td.ta-r.agce-ao-total-balance-cell.asstes_tdfirst .funding-account__subnum {\n    text-align: right;\n  }\n\n}\n\n@media (max-width: 767.98px) {\n\n  .agce-ao-sheet__fullname {\n    font-size: 12px;\n  }\n\n  .agce-ao-sheet__sym {\n    font-size: 15px;\n  }\n\n  .agce-ao-sheet__kv {\n    font-size: 14px;\n  }\n\n  .agce-ao-sheet__coin {\n    width: 32px;\n    min-width: 32px;\n    height: 32px;\n  }\n\n  .agce-ao-sheet__hero-num {\n    font-size: 22px;\n  }\n\n  .agce-ao-sheet-dialog .modal-content.agce-ao-sheet {\n    border-radius: 16px 16px 0 0;\n  }\n\n  .agce-ao-more-btn {\n    padding: 0px;\n  }\n\n  .agce-ao-sheet__table-actions .btn-link,\n  .agce-ao-sheet__table-actions .funding-account__action,\n  .agce-ao-sheet__table-actions .funding-account__action--btn {\n    min-height: 38px;\n    padding: 8px 12px;\n    font-size: 13px;\n  }\n\n\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
